<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="step step-1">
    <div class="file-upload" v-if="!isVIEWER">
      <div class="giga-file_upload">
        <div class="giga-file_upload_row">
          <div
            class="drop_files_here giga-drop-files_zone"
            :class="{
              'drop-active': $refs.upload && $refs.upload.dropActive
            }"
          >
            <div class="giga-file_upload_text">
              <i>
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_201_6190)">
                    <path
                      d="M21.2929 21.293L15.9697 15.9697L10.6465 21.293"
                      stroke="#132D48"
                      stroke-width="2.66162"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.9697 15.9697V27.947"
                      stroke="#132D48"
                      stroke-width="1.87879"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M27.1352 24.4735C28.4332 23.7658 29.4586 22.6461 30.0495 21.291C30.6404 19.9359 30.7633 18.4226 30.3986 16.9899C30.034 15.5573 29.2026 14.2868 28.0357 13.3791C26.8688 12.4714 25.4329 11.9782 23.9546 11.9772H22.2777C21.8749 10.4191 21.1241 8.97266 20.0818 7.74654C19.0395 6.52041 17.7328 5.54652 16.26 4.89809C14.7871 4.24967 13.1864 3.94357 11.5782 4.00283C9.97001 4.06208 8.39617 4.48513 6.97502 5.24019C5.55386 5.99524 4.32236 7.06265 3.37311 8.36215C2.42386 9.66166 1.78156 11.1595 1.49449 12.7429C1.20742 14.3264 1.28306 15.9543 1.71571 17.5044C2.14837 19.0544 2.92679 20.4862 3.99244 21.6921"
                      stroke="#132D48"
                      stroke-width="1.87879"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21.2929 21.293L15.9697 15.9697L10.6465 21.293"
                      stroke="#132D48"
                      stroke-width="1.87879"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_201_6190">
                      <rect width="31.9394" height="31.9394" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </i>
              <span>Glisser-Déposer vos documents</span>
            </div>
            <div class="giga-file_upload_button giga-button">
              <label class="giga-blue_button no-icon" :for="fileUploadId">
                <span>{{ $t("add_document") }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <vue-file-upload
        :input-id="fileUploadId"
        :disabled="isVIEWER"
        :post-action="postAction"
        :extensions="extensions"
        :multiple="multiple"
        :directory="directory"
        :create-directory="createDirectory"
        :thread="thread < 1 ? 1 : thread > 5 ? 5 : thread"
        :drop="drop"
        :drop-directory="dropDirectory"
        :add-index="addIndex"
        v-model="files"
        @input-filter="inputFilter"
        @input-file="inputFile"
        ref="upload"
      >
      </vue-file-upload>

      <div class="giga-files_upload" v-if="files.length">
        <div class="giga-files_upload_section">
          <div class="giga-files_upload_header">
            <div class="giga-files_header_col_action"></div>
            <div class="giga-files_header_col_name">
              <h3 class="giga-files_upload_title">
                Nom du document
              </h3>
            </div>
            <div class="giga-files_header_col_date">
              <h3 class="giga-files_upload_title">
                Date de transmission
              </h3>
            </div>
            <div class="giga-files_header_col_type">
              <h3 class="giga-files_upload_title">
                Type
              </h3>
            </div>
            <div class="giga-files_header_col_actions">
              <h3 class="giga-files_upload_title">
                Opérations
              </h3>
            </div>
            <div class="giga-files_header_col_actions">
              <h3 class="giga-files_upload_title">
                Actions
              </h3>
            </div>
          </div>

          <edit-document-type
            :replace="replace"
            :documents="this.getDrafts"
            :action-type="'add'"
            :files="files"
            :is-simulation="isSimulation"
            @draft-deleted="initFiles"
          >
          </edit-document-type>
          <div v-if="getCurrentStep === 2" class="giga-upload_files_list">
            <div>
              <template v-for="file in files">
                <div
                  v-if="!file.success"
                  :key="file.id"
                  class="giga-upload_file_item"
                >
                  <div class="giga-upload_file_action">
                    <button class="upload_file_delete_action">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.256 8L15.52 2.736C15.824 2.448 16 2.048 16 1.6C16 0.72 15.28 0 14.4 0C13.952 0 13.552 0.176 13.264 0.464L8 5.744L2.736 0.464C2.448 0.176 2.048 0 1.6 0C0.72 0 0 0.72 0 1.6C0 2.048 0.176 2.448 0.464 2.736L5.744 8L0.48 13.264C0.176 13.552 0 13.952 0 14.4C0 15.28 0.72 16 1.6 16C2.048 16 2.448 15.824 2.736 15.536L8 10.256L13.264 15.52C13.552 15.824 13.952 16 14.4 16C15.28 16 16 15.28 16 14.4C16 13.952 15.824 13.552 15.536 13.264L10.256 8Z"
                          fill="#6B829A"
                        />
                      </svg>
                    </button>
                  </div>
                  <div class="giga-upload_file_name">
                    <i class="extention-icon">
                      <img
                        v-if="getFileExtention(file.name) == 'xlsx'"
                        src="~@/assets/images/extensions/xls.svg"
                      />
                      <img
                        v-else-if="getFileExtention(file.name) == 'txt'"
                        src="~@/assets/images/extensions/txt.svg"
                      />
                      <img
                        v-else-if="getFileExtention(file.name) == 'pdf'"
                        src="~@/assets/images/extensions/pdf.svg"
                      />
                      <img
                        v-else-if="getFileExtention(file.name) == 'docx'"
                        src="~@/assets/images/extensions/doc.svg"
                      />
                      <img
                        v-else-if="getFileExtention(file.name) == 'doc'"
                        src="~@/assets/images/extensions/doc.svg"
                      />
                      <img
                        v-else-if="getFileExtention(file.name) == 'zip'"
                        src="~@/assets/images/extensions/zip.svg"
                      />
                      <img v-else src="~@/assets/images/extensions/text.svg" />
                    </i>
                    {{ file.name }}
                  </div>
                  <div class="giga-upload_file_progress progress c-progress">
                    <div
                      :class="{
                        'progress-bar': true,
                        'bg-danger': file.error,
                        'progress-bar-animated': file.active
                      }"
                      role="progressbar"
                      :style="{ width: file.progress + '%' }"
                    ></div>
                  </div>
                  <!-- <div class="giga-upload_file_status">
                      <div v-if="file.success" class="text-primary">
                        <b-icon icon="check"></b-icon>
                      </div>
                      <div v-else class="file-error">
                        <b-icon icon="x"></b-icon>
                      </div>
                    </div> -->
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div v-if="files.length && this.replace" class="giga-actions">
        <div class="giga-actions_full giga-actions_end">
          <ul class="giga-actions_row">
            <li class="giga-action_item">
              <div class="giga-button ">
                <button
                  class="giga-blue_button no-icon"
                  :disabled="fieldRequired"
                  @click.prevent="replaceDocument"
                >
                  <span>{{ $t("replace") }}</span>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { map } from "lodash";
import EditDocumentType from "./EditDocumentType";
import eventBus from "@/shared/event.bus";
import { pathConstants } from "../../../shared/pathConstants";
import { queryConstant } from "../../../shared/queryConstant";
import { constants } from "@/shared/constants";

export default {
  name: "AddDocumentStep1",
  components: { EditDocumentType },
  props: [
    "isSimulation",
    "isToBeCompleted",
    "selectDocuments",
    "fileUploadId",
    "replace",
    "isVIEWER"
  ],
  data() {
    return {
      uploadSection: true,
      files: [],
      extensions: /\.[\w]+$/i,
      minSize: 1024,
      multiple: true,
      directory: false,
      drop: true,
      dropDirectory: true,
      createDirectory: false,
      addIndex: false,
      thread: 3,
      name: "file",
      postAction: pathConstants.API + "/documents/draft-upload",
      uploadAuto: true,
      isOption: true,
      fieldRequired: true,
      customFilter: queryConstant.setDefaultCustomFilter()
    };
  },

  computed: {
    ...mapGetters("document", [
      "getCurrentStep",
      "getStep1Status",
      "getDraftDocuments",
      "getDocumentsTypes",
      "getDraftDocumentsReplace"
    ]),
    ...mapGetters("work", ["getWork"]),
    ...mapGetters("simulation", ["getSimulation"]),
    isInvalid() {
      return this.isTouched && this.value.length === 0;
    },
    getDrafts() {
      return this.replace
        ? this.getDraftDocumentsReplace
        : this.getDraftDocuments;
    }
  },
  mounted() {
    this.getDocumentsTypesAction();
    eventBus.$on("field-required", err => {
      this.fieldRequired = err;
      this.setDocFormInvalid(err);
    });
  },
  methods: {
    ...mapMutations("document", [
      "setCurrentStep",
      "setStep1Status",
      "setDraftDocuments",
      "setDraftDocumentsReplace",
      "setDocFormInvalid"
    ]),
    ...mapActions("document", [
      "getDocumentsAction",
      "getDocumentsTypesAction",
      "saveDocumentsAction"
    ]),
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files

        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        const regexBlockedExtension = new RegExp(
          `\\.(${constants.BLOCKED_EXTENSIONS.join("|")})$`,
          "i"
        );
        if (regexBlockedExtension.test(newFile.name)) {
          return prevent();
        }
      }
      if (
        this.newFileWithoutError(oldFile) &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        newFile.blob = "";
        const URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
      }
    },
    newFileWithoutError(newFile) {
      return newFile && newFile.error === "" && newFile.file;
    },
    inputFile(newFile, oldFile) {
      if (newFile && newFile.success) {
        let draftDocuments = [];
        if (!this.replace && this.getDraftDocuments) {
          draftDocuments = this.getDraftDocuments;
        } else if (this.replace && this.getDraftDocumentsReplace) {
          draftDocuments = this.getDraftDocumentsReplace;
        }
        const documentUpload = {};
        documentUpload.workId = newFile.data.workId;
        documentUpload.types = newFile.data.types;
        documentUpload.toBeCompleted = newFile.data.toBeCompleted;
        documentUpload.documentId = newFile.data.toBeCompleted
          ? this.selectDocuments[0]
          : null;
        documentUpload.fileName = newFile.response;
        documentUpload.originalFileName = newFile.file.name;
        draftDocuments.push(documentUpload);
        this.replace
          ? this.setDraftDocumentsReplace(draftDocuments)
          : this.setDraftDocuments(draftDocuments);
      }
      // Automatic upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true;
          this.moveToNextStep();
        }
      }
    },

    moveToNextStep() {
      const _step_2 = 2;
      this.setCurrentStep(_step_2);
    },

    backToPreviousStep() {
      this.files = [];
      const _step_1 = 1;
      this.setCurrentStep(_step_1);
    },
    isSimulationContext(file) {
      if (this.isSimulation) {
        file.data.workId = this.getSimulation.id;
      } else {
        file.data.workId = this.getWork.id;
      }
    },
    isToBeCompletedContext(filesLength) {
      if (this.isToBeCompleted) {
        eventBus.$emit("deleteSelectedDocument");
      } else {
        eventBus.$emit("reloadDocuments", filesLength);
      }
    },
    getFileExtention(filename) {
      return filename.split(".").pop();
    },
    replaceDocument: function() {
      const drafts = this.getDraftDocumentsReplace;
      if (drafts && drafts.length > 0) {
        drafts.forEach(document => {
          if (Array.isArray(document.types)) {
            document.types = map(document.types, "code");
          } else {
            document.types = [document.types.code];
          }
          document.operationsId =
            document.operations?.map(operation => operation.id) || [];
        });
        this.setDraftDocumentsReplace(null);
        this.saveDocumentsAction({
          id: parseInt(this.$route.params["id"], 10),
          customFilter: this.customFilter,
          documentsToUpload: drafts
        });
      }
      eventBus.$emit("unselectDocs");
      eventBus.$emit("deleteSelectedDocument");
    },
    initFiles() {
      if (this.getDraftDocuments && this.getDraftDocuments.length === 0) {
        this.files = [];
      }
    }
  },
  watch: {
    files: function() {
      this.files.forEach(file => {
        this.isSimulationContext(file);
        file.data.types = map(file.types, "code");
        file.data.toBeCompleted = this.isToBeCompleted;
        file.data.documentId = this.isToBeCompleted
          ? this.selectDocuments
          : null;
      });
      if (
        this.files.length &&
        this.$refs.upload &&
        this.$refs.upload.uploaded
      ) {
        let errorFlg = false;
        this.files.forEach((item, idx, array) => {
          if (item.error) {
            errorFlg = true;
          }
          if (idx === array.length - 1 && !errorFlg) {
            // this.isToBeCompletedContext(this.files.length);
          }
        });
      }
    }
  },
  beforeDestroy() {
    eventBus.$off("field-required");
  }
};
</script>
